import { Component, OnDestroy, OnInit } from '@angular/core';
import { AppComponent } from '../../app.component';
import { AppMainComponent } from '../../app.main.component';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { getUserDefaultProfile, getUserEmployeeId, getUserRoles } from 'src/app/core/functions';
import { AuthService } from 'src/app/auth/auth.service';
import { Permission } from 'src/app/core/enums/permissions';
import { AppearanceService } from 'src/app/shared/appearance.service';
import { Profile } from 'src/app/core/enums/profile';
import { Subscription } from 'rxjs';
import { Theme } from 'src/app/core/enums/theme-type';

@Component({
    selector: 'app-topbar',
    templateUrl: './app.topbar.component.html',
    styleUrls: ['./app.topbar.component.scss'],
    standalone: false
})
export class AppTopbarComponent implements OnInit, OnDestroy {

    employeeId: string;
    loading: boolean = true;
    isAdmin: boolean;
    profile: Profile;
    isDark: boolean = false;

    private _subs: Subscription[] = [];

    constructor(
        public app: AppComponent,
        public appMain: AppMainComponent,
        public afAuth: AngularFireAuth,
        public authService: AuthService,
        public appearanceService: AppearanceService
    ) {}

    ngOnInit(): void {
        this._subs.push(
            this.appearanceService.theme$.subscribe(t => {
                this.isDark = t === Theme.Dark;
            }),
            this.afAuth.idTokenResult.subscribe(user => {
                if (user) {
                    this.employeeId = getUserEmployeeId(user.claims);
                    this.profile = getUserDefaultProfile(user.claims);
                    this.isAdmin = getUserRoles(user.claims).includes(Permission.Admin);
                    this.loading = false;
                }
            })
        );
    }

    ngOnDestroy(): void {
        this._subs.forEach(s => s.unsubscribe());
    }

    toggleTheme(): void {
        this.appearanceService.toggle();
    }

    logout(): void {
        this.authService.SignOut();
    }
}

